import styled from "styled-components";
import checkMarkIcon from "../../assets/icons/checkMarkIcon.svg";
import { pxToRem } from "../../styles/utils";

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  border-radius: ${pxToRem(24)};
  box-shadow: ${pxToRem(4)} ${pxToRem(4)} ${pxToRem(14)} 0px rgba(202, 202, 202, 0.25),
    ${pxToRem(-4)} ${pxToRem(-4)} ${pxToRem(14)} 0px rgba(202, 202, 202, 0.25);
  background: rgb(255, 255, 255);
  width: ${pxToRem(202)};
  height: ${pxToRem(256)};
  padding: ${pxToRem(20)};
  padding-bottom: ${pxToRem(12)};
  z-index: 10;
`;

export const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;  

export const OptionItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${pxToRem(8)};
  cursor: pointer;

  input {
    display: none;
  }

  label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  span {
    font-size: ${pxToRem(16)};
    color: #333;
    margin-left: ${pxToRem(8)};
  }

  input:checked + label::before {
    content: "";
    display: inline-block;
    width: ${pxToRem(28)};
    height: ${pxToRem(28)};
    border: ${pxToRem(2)} solid rgb(114, 82, 220);
    border-radius: ${pxToRem(8)};
    background: rgb(114, 82, 220);
    background-image: url(${checkMarkIcon});
    background-repeat: no-repeat;
    background-position: center;
    background-size: ${pxToRem(12)} ${pxToRem(12)};
  }

  input + label::before {
    content: "";
    display: inline-block;
    width: ${pxToRem(28)};
    height: ${pxToRem(28)};
    border: ${pxToRem(1)} solid rgb(185, 185, 185);
    border-radius: ${pxToRem(8)};
    background-color: white;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  margin-top: ${pxToRem(12)};
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: ${pxToRem(-22)};
    left: 0;
    right: 0;
    height: ${pxToRem(1)};
    background-color: rgba(31, 10, 53, 0.1);
  }
`;

export const SaveButton = styled.button`
  color: rgb(255, 255, 255);
  font-size: ${pxToRem(16)};
  font-weight: 600;

  border: none;
  border-radius: ${pxToRem(12)};
  background: rgb(114, 82, 220);
  padding: ${pxToRem(14)} ${pxToRem(28)};
  cursor: pointer;
  width: ${pxToRem(162)};
  height: ${pxToRem(40)};

  &:hover {
    background: #5a0cad;
  }
`;

export const ResetButton = styled.button`
  background: none;
  color: rgb(143, 132, 154);
  font-size: ${pxToRem(16)};
  font-weight: 500;
  border: none;
  cursor: pointer;
  padding: ${pxToRem(8)} ${pxToRem(12)};
  text-decoration: none;
`;
